import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Slot } from 'components/slot';
import { SlotsType, SlotType } from 'components/slot/types';

export type PageWithTitleType = {
    title?: React.ReactNode;
    children: React.ReactNode;
    slot?: SlotsType | SlotType;
    titleClassName?: string;
    mobileInlineHeader?: boolean;
};

const PageWithTitleLayout: FC<PageWithTitleType> = ({
    title,
    children,
    slot,
    titleClassName,
    mobileInlineHeader = false,
}) => {
    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}>
            <Box
                sx={{
                    paddingY: title || slot ? 2 : 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: mobileInlineHeader
                        ? { xs: 'nowrap', sm: 'wrap' }
                        : 'wrap',
                    gap: 1,
                    minWidth: 0,
                }}>
                <Slot name="start" slot={slot} />
                <Typography
                    sx={{
                        color: 'text.primary',
                        fontSize: { xs: '16px', md: '20px' },
                        minWidth: 0,
                        flex: mobileInlineHeader
                            ? { xs: '1 1 auto', sm: '1 1 240px' }
                            : '1 1 240px',
                        overflowWrap: 'anywhere',
                    }}
                    className={titleClassName ?? 'font-yekan-heavy'}>
                    {title}
                </Typography>
                <Slot slot={slot} />
            </Box>

            <Box sx={{ minWidth: 0 }}>{children}</Box>
        </Box>
    );
};

export default PageWithTitleLayout;
